/** Default page size for Discover search endpoints (hotels, flights, places). */
export const DISCOVER_DEFAULT_PAGE_SIZE = 20;

export function getTotalPages(count: number, pageSize: number = DISCOVER_DEFAULT_PAGE_SIZE): number {
  if (count <= 0) return 1;
  return Math.max(1, Math.ceil(count / pageSize));
}

export function shouldShowPagination(totalPages: number): boolean {
  return totalPages > 1;
}
